'use client';

import { createContext, useCallback, useContext, useLayoutEffect, useMemo, useState } from 'react';
import type { RefObject } from 'react';

export interface PopoverContextValue {
    setScrollRef: (element: HTMLElement | null) => void;
}

export const PopoverContext = createContext<PopoverContextValue | null>(null);

export const usePopoverScrollRef = () => {
    const [scrollElement, setScrollElement] = useState<HTMLElement | null>(null);

    const setScrollRef = useCallback((element: HTMLElement | null) => {
        setScrollElement(element);
    }, []);

    const scrollRef = useMemo(() => ({ current: scrollElement }), [scrollElement]);
    const popoverContext = useMemo(
        () => ({
            setScrollRef,
        }),
        [setScrollRef],
    );

    return {
        popoverContext,
        scrollElement,
        scrollRef,
        setScrollRef,
    };
};

export const useRegisterPopoverScrollRef = (ref: RefObject<HTMLDivElement | null>) => {
    const popoverContext = useContext(PopoverContext);

    useLayoutEffect(() => {
        if (!popoverContext) return;

        popoverContext.setScrollRef(ref.current);

        return () => {
            popoverContext.setScrollRef(null);
        };
    }, [popoverContext, ref]);
};
